import { useI18n } from "@/lib/i18n/store";
import type { Locale } from "@/lib/i18n/locales";
import { useCatalogText } from "./use-catalog-text";

export function useCatalogLocale(): Locale {
  const locale = useI18n((state) => state.locale);
  useCatalogText(locale);
  return locale;
}
